import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { ModuleDataPayload, ModuleDataResponse } from "@/types/interface/module";

async function createModule(payload: ModuleDataPayload) {
  return await http.post<APIResponse<ModuleDataResponse>>("module/create", payload);
}

async function updateModule(idModule = '', payload: ModuleDataPayload) {
  return await http.patch<APIResponse<ModuleDataResponse>>(`module/update?id=${idModule}`, payload);
}

async function getModule(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<ModuleDataResponse>>(`module?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findModule(idModule = "") {
  return await http.get<APIResponse<ModuleDataResponse>>(`module/detail?id=${idModule}`);
}

async function deleteModule(idModule = "") {
  return await http.delete<APIResponse<ModuleDataResponse>>(`module/delete?id=${idModule}`);
}

export default {
  createModule,
  updateModule,
  getModule,
  findModule,
  deleteModule
};